export default __webpack_public_path__ + "static/media/coderwall.5b05afa4.svg";